import { createHashRouter } from "react-router-dom";

// import { jmacxApi } from "./api/jmacx";
import Index from "./pages";
import Root from "./root";

const routeLoader = async () => {
  // const result = await jmacxApi.endpoints.getVehicles.initiate();
  // if ("data" in result) {
  //   return { vehicles: result.data };
  // }

  return true;
};

const router = createHashRouter(
  [
    {
      path: "/",
      element: <Root />,
      children: [
        {
          path: "/",
          element: <Index />,
          loader: routeLoader,
        },
      ],
    },
  ],
  {
    basename: "/",
  },
);

export default router;
